import logo from "./logo.svg";
import "src/assets/sassStyles/_global.scss";
import { Route, Routes } from "react-router-dom";
import TrainerDirectory from "./components/pages/trainerDirectory";
import LinkLogin from "./components/pages/LinkLogin";
import ProtectedRoute from "./ProtectedRoute/ProtectedRoute";
import { useState } from "react";
import PractitionerDirectory from "./components/pages/Practitioner/PractitionerDirectory";
import PractitionerRegister from "./components/pages/Practitioner/PractitionerRegister";
export default function App() {
  const [user, setUser] = useState(null);
  return (
    <>
      <Routes>
        <Route exact path="/" element={<TrainerDirectory />}></Route>
        <Route
          exact
          path="/Practitioner/PractitionerDirectory"
          element={<PractitionerDirectory />}
        ></Route>
        <Route
          exact
          path="/Practitioner/PractitionerRegister"
          element={<PractitionerRegister />}
        ></Route>
        <Route
          exact
          path="/LinkLogin/:authguid/:authtype"
          element={<LinkLogin />}
        ></Route>
        <Route
          path="analytics"
          element={
            <ProtectedRoute
              redirectPath="/home"
              isAllowed={!!user && user.permissions.includes("counselor")}
            >
              <PractitionerRegister />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}
